/* quick-add.js — AJAX add-to-cart + buy-now on product cards.
   - [data-quick-add-form] submit → /cart/add.js → dispatches cart:added
   - [data-buy-now-card]      click  → /cart/add.js → redirect to /checkout
*/
(function () {
  function findTitle(node) {
    const card = node.closest('.card-product, .product-guide__card, .product-guide__item');
    if (!card) return null;
    return (
      card.querySelector('.card-product__title')?.textContent.trim() ||
      card.querySelector('.product-guide__title')?.textContent.trim() ||
      null
    );
  }

  /* A POST can be applied by Shopify while its response is lost on the
     way back. Reporting that as a failure invites a second tap and a
     doubled order, so check the cart before saying anything. */
  function readCartCount() {
    const el = document.querySelector('[data-cart-count]');
    if (!el) return null;
    const n = parseInt(el.textContent.trim(), 10);
    return Number.isFinite(n) ? n : null;
  }

  async function addDidLand(countBefore) {
    if (countBefore === null) return false;
    try {
      const r = await fetch('/cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' });
      if (!r.ok) return false;
      const cart = await r.json();
      return typeof cart.item_count === 'number' && cart.item_count > countBefore;
    } catch (e) {
      return false;
    }
  }

  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('[data-quick-add-form]');
    if (!form) return;
    e.preventDefault();
    const btn = form.querySelector('[data-quick-add-btn]');
    if (btn && btn.hasAttribute('disabled')) return;
    if (btn) { btn.classList.add('is-loading'); btn.setAttribute('disabled', ''); }
    const data = new FormData(form);
    const countBefore = readCartCount();
    const announce = () => {
      const title = findTitle(form);
      document.dispatchEvent(new CustomEvent('cart:added', { bubbles: true, detail: { title } }));
    };
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: data
      });
      if (!res.ok) {
        let reason = '';
        try {
          const body = await res.json();
          reason = body.description || body.message || '';
        } catch (err2) {}
        const err = new Error(reason || 'add failed');
        err.userMessage = reason;
        throw err;
      }
      announce();
    } catch (err) {
      const landed = !err.userMessage && await addDidLand(countBefore);
      if (landed) {
        announce();
      } else if (window.LaNuit && window.LaNuit.toast) {
        window.LaNuit.toast(err.userMessage || 'We could not add this to your cart. Please check your connection and try again.', { variant: 'error' });
      }
    } finally {
      if (btn) {
        setTimeout(() => { btn.classList.remove('is-loading'); btn.removeAttribute('disabled'); }, 600);
      }
    }
  });

  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-buy-now-card]');
    if (!btn || btn.disabled) return;
    e.preventDefault();
    const variantId = btn.dataset.variantId;
    if (!variantId) return;
    btn.classList.add('is-loading');
    btn.disabled = true;
    try {
      const body = new FormData();
      body.set('id', variantId);
      body.set('quantity', '1');
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body
      });
      if (!res.ok) throw new Error('add failed');
      window.location.href = '/checkout';
    } catch (err) {
      btn.classList.remove('is-loading');
      btn.disabled = false;
      if (window.LaNuit && window.LaNuit.toast) {
        window.LaNuit.toast('Could not start checkout. Try again.', { variant: 'error' });
      }
    }
  });
})();
